// Copies an object to create a new one
export default function cloneObject(obj) {
  return JSON.parse(JSON.stringify(obj));
}

export function getUniqueListBy(arr, key) {
  return [...new Map(arr.map((item) => [item.properties[key], item])).values()];
}
